import CompanyTabs from "./company-tabs";

export default CompanyTabs;